import'string.prototype.startswith';
import React from 'react';
import '../style/newSolicitorForm.css';
import Dots from 'react-activity/lib/Dots';
import '../style/dots.css';
import FormResponseMessage from "./formResponseMessage";
import FormGroupTextInput from "./formGroupTextInput";
import Button from "./button";
import Dropzone from 'react-dropzone';
import GeneralSVG from "./generalSVG";
import CenteredDots from "./General/centeredDots";
import moment from 'moment';
import FormGroupDateInput from "./General/formGroupDateInput";
import CustomModal from "./General/customModal";
import TobaRevision from "./Tobas/tobaRevision";
import FormGroupSelectMany from "./General/formGroupSelectMany";
import _ from 'lodash';
import CustomEditor from "./General/CustomEditor";
import {DROPZONE_ACCEPTED_FILES, LEGAL_ADVICE_TEXT, TOBA_SHORT_TEXT} from "../helpers/variables";

const NewTobaForm = (props) => { 

    if(props.toba.fetchingToba){
        return (
            <CenteredDots
            />
        )
    }
    let colorStyleMap = {
        BACKGROUNDCOLOR: {
            "backgroundColor": "rgb(255, 212, 2)"
        }
    };
    return (
        <div className="row">
            <div className="col-sm-12 ">
                <CustomModal
                    isOpen={props.toba.confirmTobaUpdateModalOpen}
                    content={<div>
                        <p>
                            {`You are about to update a ${TOBA_SHORT_TEXT}.` + (
                                moment(moment(props.toba.tobaFormData.validFrom, 'DD/MM/YYYY')).isBefore(
                                    moment())?
                                    ` ${LEGAL_ADVICE_TEXT} Users who have accepted it will not be prompted to do so again.`:''
                            )}
                        </p>
                        <p>Are you sure?
                        </p>
                        <Button wrapper="btn-wrapper-forForms"
                                clickHandler={() => {
                                    props.closeUpdateTobaConfirmModal();
                                    props._patchToba();
                                }}
                                btnType="submit" btnStyle={'btn btn-primary btn-xs sharp yellow'}
                                label={'Yes'}/>
                        <Button wrapper="btn-wrapper-forForms"
                                clickHandler={props.closeUpdateTobaConfirmModal}
                                btnType="submit" btnStyle={'btn btn-primary btn-xs sharp blue'}
                                label={'No'}/>
                    </div>}
                    handleClose={props.closeUpdateTobaConfirmModal}
                />
                <CustomModal
                    isOpen={props.toba.confirmRevisionCreateModalOpen}
                    content={<div>
                        <p>You are about to create a new revision of this {TOBA_SHORT_TEXT}.  Affected {LEGAL_ADVICE_TEXT} Users will
                            have to accept the new {TOBA_SHORT_TEXT} revision when this becomes live.
                        </p>
                        {
                            (props._futureTobaRevisionsExists()) && (
                                <div>
                                    <p>
                                        All revisions of this {TOBA_SHORT_TEXT} starting in the future will be erased.
                                    </p>
                                    <ul>
                                        {
                                            _.map(props._getFutureTobaRevisions(), i => {
                                                return <li key={i.id}>
                                                    {i.name +  ' | '}
                                                    {'Valid '}<b>{'from '}</b>
                                                    {moment(i.validFrom).format('DD/MM/YYYY - HH:mm:ss')}
                                                    {
                                                        moment(i.validUntil).isValid()?
                                                            <span><b>{' until '}</b>
                                                                {moment(i.validUntil).format('DD/MM/YYYY - HH:mm:ss')}
                                                            </span>
                                                            :
                                                            null
                                                    }
                                                </li>
                                            })
                                        }
                                    </ul>
                                </div>
                            )
                        }
                        <p>Are you sure?</p>
                        <Button wrapper="btn-wrapper-forForms"
                                clickHandler={() => {
                                    props.closeCreateRevisionConfirmModal();
                                    props._createToba();
                                }}
                                btnType="submit" btnStyle={'btn btn-primary btn-xs sharp yellow'}
                                label={'Yes'}/>
                        <Button wrapper="btn-wrapper-forForms"
                                clickHandler={props.closeCreateRevisionConfirmModal}
                                btnType="submit" btnStyle={'btn btn-primary btn-xs sharp blue'}
                                label={'No'}/>
                    </div>}
                    handleClose={props.closeCreateRevisionConfirmModal}
                />
                <div className="row">
                    <h2 className="solicitor-form-title col-sm-12">
                        {props.editingForm
                             ? `Edit ${TOBA_SHORT_TEXT}`
                             : `Create ${TOBA_SHORT_TEXT}`}
                    </h2>

                </div>
                <form className="form-horizontal solicitor-form-wrapper " onSubmit={(evt) => props.handleSubmit(evt)}>
                    {
                        props.toba.tobaFormData.defaultToba && props.editingForm?
                            null
                            :
                            <FormGroupTextInput
                                Disabled={props.toba.tobaFormData.defaultToba}
                                InputWrapper="col-sm-6 formGroup-textInput-input-wrapper"
                                Label="Name"
                                Required={true}
                                Name="name"
                                Type="text"
                                Value={props.toba.tobaFormData.name}
                                HandleInputChange={props.handleInputChange}/>

                    }
                    <FormGroupTextInput
                        InputWrapper="col-sm-6 formGroup-textInput-input-wrapper"
                        Label="Version Name"
                        Required={true}
                        Name="version"
                        Type="text"
                        Value={props.toba.tobaFormData.version}
                        HandleInputChange={props.handleInputChange}/>
                    {
                        props.toba.tobaFormData.defaultToba && props.editingForm?
                            null
                            :
                            <div>
                                <FormGroupTextInput
                                    Placeholder={`Quick search for ${LEGAL_ADVICE_TEXT} Groups`}
                                    InputWrapper="col-sm-6 formGroup-textInput-input-wrapper"
                                    Label={`${LEGAL_ADVICE_TEXT} Groups`}
                                    Name="solicitorGroupFilter"
                                    Type="text"
                                    Value={props.toba.tobaFormData.solicitorGroupFilter}
                                    HandleInputChange={props.handleInputChange}/>
                                <FormGroupSelectMany
                                    leftClassName={'col-sm-3'}
                                    centerClassName={'col-sm-6'}
                                    name={'selectedSolicitorGroups'}
                                    options={props.selectGroupOptions}
                                    handleChange={props.handleInputChange}
                                    checkedItems={props.toba.tobaFormData.selectedSolicitorGroups}
                                />
                            </div>

                    }
                    <div className="form-group">
                        <div className="col-sm-3">
                            <label className="control-label.text-left formGroup-textInput-label">
                                Content<span>{' '}*</span>
                            </label>
                        </div>
                        <div className="col-sm-6  formGroupTextArea-wrapper">
                            <CustomEditor
                                value={props.toba.tobaFormData.tobaBody}
                                onEditorChange={(content) => {
                                    props.handleInputChange('tobaBody', content);
                                }}
                            />
                        </div>
                    </div>
                    <FormGroupDateInput
                        autoComplete={'off'}
                        centerClassName="col-sm-6 formGroup-textInput-input-wrapper"
                        leftClassName="col-sm-3"
                        label="Valid from"
                        required={true}
                        name="validFrom"
                        Key="validFrom"
                        min={moment().format('DD/MM/YYYY')}
                        type="text"
                        value={props.toba.tobaFormData.validFrom}
                        handleInputChange={props.handleInputChange}/>
                    <div className="form-group">
                        <div className="col-sm-3"></div>
                        <div className="col-sm-6">
                            <Dropzone onDropAccepted={props._onDrop}
                                      accept={DROPZONE_ACCEPTED_FILES}
                                      className="newApplication-dropzone">
                                <p>Try dropping some files here, or click to select files to upload.</p>
                            </Dropzone>
                        </div>
                    </div>
                    {
                        _.size(props.toba.tobaFormData.selectedSolicitorGroups) > 0 ?
                            <div className={'form-group'}>
                                <div className={'col-sm-6 col-sm-offset-3'}>
                                    <h4>Selected {LEGAL_ADVICE_TEXT} Groups</h4>
                                    <ul className="unorderedListNoBulletsAndSpace">
                                        {
                                            _.map(props.toba.tobaFormData.selectedSolicitorGroups, item => {
                                                return <li key={item.id}>{item.name}</li>
                                            })
                                        }
                                    </ul>
                                </div>
                            </div>
                            :
                            null
                    }
                    {
                        props.toba.tobaFormData.id?
                            <div className="form-group">
                                <div className="col-sm-3">
                                </div>
                                <div className="col-sm-6 ">
                                    <Button wrapper="btn-wrapper-forForms"
                                            btnType="submit" btnStyle={'btn btn-primary btn-xs sharp yellow'}
                                            label={'Save & Create New Revision'}/>
                                    <Button wrapper="btn-wrapper-forForms"
                                            clickHandler={props._handleUpdate}
                                            btnType="submit" btnStyle={'btn btn-primary btn-xs sharp blue'}
                                            label={'Save Current Revision'}/>
                                    <Button clickHandler={props.goBack} wrapper="btn-wrapper-forForms"
                                            btnType="button" btnStyle={'btn btn-primary btn-xs sharp white'}
                                            label="Cancel"/>
                                </div>
                                <div className="col-sm-3"></div>
                            </div>
                            :
                            <div className="form-group">
                                <div className="col-sm-3">
                                </div>
                                <div className="col-sm-6 ">
                                    <Button wrapper="btn-wrapper-forForms"
                                            btnType="submit" btnStyle={'btn btn-primary btn-xs sharp yellow'}
                                            label={props.editingForm?'Save': `Create ${TOBA_SHORT_TEXT}`}/>
                                    <Button clickHandler={props.editingForm?props.goBack:props._handleCancel} wrapper="btn-wrapper-forForms"
                                            btnType="button" btnStyle={'btn btn-primary btn-xs sharp white'}
                                            label="Cancel"/>
                                </div>
                                <div className="col-sm-3"></div>
                            </div>
                    }
                    {
                        (props.toba.badResponse !== '') ?
                            <div>
                                <FormResponseMessage LeftWrapper="col-sm-3"
                                                     CenterWrapper="col-sm-6"
                                                     MessageStyle="formResponseMessage-reject"
                                                     Message={ props.toba.badResponse}/>
                            </div>
                            :
                            null
                    }
                    {
                        (props.toba.successMsg !== '') ?
                            <FormResponseMessage LeftWrapper="col-sm-3"
                                                 CenterWrapper="col-sm-6"
                                                 MessageStyle="formResponseMessage-success"
                                                 Message={props.toba.successMsg}/>
                            :
                            null
                    }
                    {
                        (props.toba.failMsg !== '') ?
                            <FormResponseMessage LeftWrapper="col-sm-3"
                                                 CenterWrapper="col-sm-6 "
                                                 MessageStyle="formResponseMessage-reject"
                                                 Message={props.toba.failMsg}/>
                            :
                            null
                    }
                    {
                        props.toba.posting ?
                            <div className="form-group">
                                <div className="col-sm-3">
                                </div>
                                <div className="col-sm-9">
                                    <div className="col-sm-4"></div>
                                    <Dots />
                                </div>
                            </div>
                            :
                            null

                    }
                    {
                        (props.toba.updateTobaSuccessMessage !== '') ?
                            <FormResponseMessage LeftWrapper="col-sm-3"
                                                 CenterWrapper="col-sm-6"
                                                 MessageStyle="formResponseMessage-success"
                                                 Message={props.toba.updateTobaSuccessMessage}/>
                            :
                            null
                    }
                    {
                        (props.toba.updateTobaFailMessage !== '') ?
                            <FormResponseMessage LeftWrapper="col-sm-3"
                                                 CenterWrapper="col-sm-6"
                                                 MessageStyle="formResponseMessage-reject"
                                                 Message={props.toba.updateTobaFailMessage}/>
                            :
                            null
                    }
                    {
                        props.toba.updatingToba && (
                            <CenteredDots/>
                        )
                    }
                </form>
                <div className="row">
                    <div className="col-sm-3"></div>
                    <div className="col-sm-6">
                        <ul className="newApplication-attachment-list">
                            {props.toba?.tobaFormData?.attachments?.length > 0 ?
                                props.toba.tobaFormData.attachments.map((attachments, index) => {
                                    return <li key={index}>
                                        <div className="row">
                                            <div className="col-sm-12 attachment-remove__wrapper">
                                                <div
                                                    className="attachment-remove"
                                                    onClick={() => props._removeTobaFormAttachment(index)}>X
                                                </div>
                                                {'  '}
                                                {attachments.name}
                                            </div>
                                        </div>
                                    </li>
                                })
                                :
                                null
                            }
                        </ul>
                    </div>
                </div>
                {
                    props.editingForm && props.toba?.tobaFormData?.fetchedTobaAttachments?.length > 0?
                        <div className="row">
                            <div className="col-sm-3"></div>
                            <div className="col-sm-6">
                                <hr className="appFormRefSettings-hr"/>
                                <h4 >Files Already Attached.</h4>
                                <ul className="newApplication-attachment-list">
                                    {
                                        props.toba.tobaFormData.fetchedTobaAttachments.map((attachments, index) => {
                                            return <li key={index}>
                                                <div className="row">
                                                    <div className="col-sm-12 attachment-remove__wrapper">
                                                        <div
                                                            className="attachment-remove"
                                                            onClick={() => props._removeFetchedTobaAttachment(index)}>X
                                                        </div>
                                                        {'  '}
                                                        <a onClick={() => props._getFileFromBase64(attachments)}
                                                           className="applicationPolicy-document-tab-link">
                                                            <GeneralSVG
                                                                SvgWrapper="generalTab-download-wrapper inlineBlock"
                                                                Label="Download"
                                                                Svg={<svg xmlns="http://www.w3.org/2000/svg"
                                                                          viewBox="0 0 10 10"><title>Asset
                                                                    9</title>
                                                                    <g id="Layer_2" data-name="Layer 2">
                                                                        <g id="info">
                                                                            <path
                                                                                d="M9.5,6a.5.5,0,0,0-.5.5V9H1V6.5a.5.5,0,0,0-1,0V10H10V6.5A.5.5,0,0,0,9.5,6Z"/>
                                                                            <path
                                                                                d="M5,7.21,7.35,4.85a.5.5,0,0,0-.71-.71L5.5,5.29V0h-1V5.29L3.35,4.15a.5.5,0,0,0-.71.71Z"/>
                                                                        </g>
                                                                    </g>
                                                                </svg>}
                                                            />
                                                        </a>
                                                        {' ' + attachments.name}
                                                    </div>
                                                </div>
                                            </li>
                                        })
                                    }
                                </ul>
                            </div>

                        </div>
                        :
                        null
                }
                <div>
                    <div className="row">
                        <div className="col-sm-12">
                            <hr className=" applicationPolicy-hr"/>
                        </div>
                    </div>
                    <div className="row">
                        <h3 className="col-sm-12 applicationPolicy-h2">  {TOBA_SHORT_TEXT} Revisions</h3>
                    </div>
                    {
                        props.toba.fetchingTobaRevisions && (
                            <CenteredDots/>
                        )
                    }
                    {
                        (props.toba?.previousTobas?.length > 0) && (
                            <div>
                                <ul>
                                    {
                                        props.toba.previousTobas.map((toba, index) => {
                                            return <li key={index} onClick={() => {
                                                props.openTobaRevisionModal();
                                                props.getTobaRevisionById({tobaId: toba.id});
                                            }} className="applicationPolicy-update-tab-PreviousUpdates-list-item">
                                            <span>
                                                {'Valid '}<b>{'from '}</b>{moment(toba.validFrom).format('DD/MM/YYYY - HH:mm:ss')}
                                                {
                                                    moment(toba.validUntil).isValid()?
                                                        <span><b>{' until '}</b>{moment(toba.validUntil).format('DD/MM/YYYY - HH:mm:ss')}</span>
                                                        :
                                                        null
                                                }
                                                {
                                                    (props.toba.tobaFormData.id === toba.id) && (
                                                        <span className="toba-revision-state">
                                                            {"EDITING NOW"}
                                                        </span>
                                                    )
                                                }
                                                {
                                                    props.tobaIsLive(toba) && (
                                                        <span className="toba-revision-state">
                                                            {"LIVE VERSION"}
                                                        </span>
                                                    )
                                                }
                                            </span>
                                            </li>
                                        })
                                    }
                                </ul>
                                <CustomModal
                                    isOpen={props.toba.openModal}
                                    content={<TobaRevision
                                        defaultToba={props.toba.tobaFormData.defaultToba}
                                        tobaRevision={props.toba.selectedPreviousToba}
                                        fetchingTobaRevision={props.toba.fetchingTobaRevision}
                                        populateTobaFormFromRevision={props.populateTobaFormFromRevision}
                                        _getFileFromBase64={props._getFileFromBase64}
                                    />}
                                    handleClose={() => props.closeTobaRevisionModal()}
                                />
                            </div>
                        )
                    }
                </div>
            </div>
        </div>
    )
};

export default NewTobaForm;